module.exports = __webpack_public_path__ + "static/logo-name-insurance-30a8bee6d7eac8255314f6e793627bcc.png";